<template>
  <div class="top-back">
    <a v-if="ltiReturnUrl" :href="ltiReturnUrl" class="dashboard-active-item">
      <em class="icon-back"></em>
      Return to Course
    </a>
    <router-link v-else to="/active" class="dashboard-active-item">
      <em class="icon-back"></em>
      Back to Dashboard
    </router-link>
  </div>
</template>
<script>
import { utilFunctionService } from "@/utils/utils.service";

export default {
  name: "backDashboard",
  computed: {
    ltiReturnUrl() {
      return utilFunctionService.getLocalStorageService("lti_return_url") || null;
    }
  }
};
</script>
